import React from "react";
import {
  Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel,
  Badge, Box, Button, Container, Grid, GridItem, Heading, HStack,
  ListItem, Text, UnorderedList, VStack
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const brand = { green: "#1C4C3F", cream: "#F7F5EB" };

export default function Pricing() {
  return (
    <Box bg={brand.cream}>
      {/* Hero */}
      <Container maxW="6xl" px={{ base: 4, md: 6 }} py={{ base: 16, md: 24 }}>
        <VStack spacing={3} textAlign="center">
          <Heading size="2xl">Simple pricing</Heading>
          <Text fontSize="lg" opacity={0.9}>
            Founder-friendly. Try it free—cancel anytime.
          </Text>
        </VStack>
      </Container>

      {/* Plans – show both */}
      <Container maxW="6xl" px={{ base: 4, md: 6 }} pb={{ base: 12, md: 16 }}>
        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
          {/* Yearly (best value) */}
          <GridItem>
            <Box
              bg="white"
              border="1px solid #EAEAEA"
              borderRadius="lg"
              p={{ base: 6, md: 8 }}
            >
              <HStack justify="space-between" mb={1}>
                <Heading size="lg">$189 / year</Heading>
                <Badge colorScheme="green">Best value</Badge>
              </HStack>
              <Text>Everything you need to turn data into buyer-ready slides.</Text>
              <UnorderedList spacing={2} mt={2} mb={6}>
                <ListItem>
                  AI advisors (strategy, trade, category, buyer, analyst)
                </ListItem>
                <ListItem>Auto-charting (PNG/PDF export)</ListItem>
                <ListItem>Pricing & promo tools</ListItem>
                <ListItem>Email support</ListItem>
              </UnorderedList>
              <VStack align="stretch">
                <Button
                  as={RouterLink}
                  to="/signup?plan=yearly"
                  size="lg"
                  bg={brand.green}
                  color="white"
                >
                  Start yearly
                </Button>
                <Text
                  fontSize="sm"
                  color="gray.600"
                  textAlign="center"
                >
                  Save vs monthly
                </Text>
              </VStack>
            </Box>
          </GridItem>

          {/* Monthly */}
          <GridItem>
            <Box
              bg="white"
              border="1px solid #EAEAEA"
              borderRadius="lg"
              p={{ base: 6, md: 8 }}
            >
              <Heading size="lg" mb={1}>
                $19.99 / month
              </Heading>
              <Text>Everything you need to turn data into buyer-ready slides.</Text>
              <UnorderedList spacing={2} mt={2} mb={6}>
                <ListItem>
                  AI advisors (strategy, trade, category, buyer, analyst)
                </ListItem>
                <ListItem>Auto-charting (PNG/PDF export)</ListItem>
                <ListItem>Pricing & promo tools</ListItem>
                <ListItem>Email support</ListItem>
              </UnorderedList>
              <VStack align="stretch" minW={{ md: "240px" }}>
                <Button
                  as={RouterLink}
                  to="/signup?plan=monthly"
                  size="lg"
                  variant="outline"
                >
                  Start monthly
                </Button>
                <Button as="a" href="/contact" variant="ghost">
                  Talk to us
                </Button>
              </VStack>
            </Box>
          </GridItem>
        </Grid>
      </Container>

      {/* FAQ */}
      <Container maxW="6xl" px={{ base: 4, md: 6 }} pb={{ base: 16, md: 20 }}>
        <Heading size="lg" mb={4}>
          FAQ
        </Heading>
        <Accordion allowToggle>
          <AccordionItem>
            <h3>
              <AccordionButton>
                <Box flex="1" textAlign="left">
                  Is there a free trial?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h3>
            <AccordionPanel>
              Yes—we are offering one month free.
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem>
            <h3>
              <AccordionButton>
                <Box flex="1" textAlign="left">
                  Can I cancel anytime?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h3>
            <AccordionPanel>
              Absolutely. Your subscription stops at the end of the current
              period.
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem>
            <h3>
              <AccordionButton>
                <Box flex="1" textAlign="left">
                  How is my data handled?
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h3>
            <AccordionPanel>
              Your data stays yours. It isn’t used to train public models and
              you can delete datasets/chats anytime.
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Container>
    </Box>
  );
}
